import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

export const getAggregatorWalletSignatories = async (id: number) => {
  const data = await getData(
    `${ajaxEndpoints.AGGREGATOR_WALLET_SIGNATORIES}?aggregatorId=${id}`
  );
  return data;
};

export default function useAggregatorWalletSignatories(id: number) {
  return useQuery(
    [id, "allAggregatorWalletSignatories"],
    getAggregatorWalletSignatories,
    {
      refetchOnWindowFocus: false,
    }
  );
}
